import { useEquipments } from "@root/hooks/useEquipments";
import React, { createContext, useContext, ReactNode } from "react";

const EquipmentContext = createContext<any>(undefined);

interface EquipmentContextProviderProps {
  children: ReactNode;
}

export const EquipmentContextProvider: React.FC<
  EquipmentContextProviderProps
> = ({ children }) => {
  const data = useEquipments();
  return (
    <EquipmentContext.Provider value={data}>
      {children}
    </EquipmentContext.Provider>
  );
};

export const useEquipmentContext = () => {
  const context = useContext(EquipmentContext);
  return context;
};
